// ** React Imports
import { lazy } from "react"
import { Navigate } from "react-router-dom"

const Cases = lazy(() => import("../../views/pages/cases"))
const CasesHome = lazy(() => import("../../views/pages/cases/home"))
const CaseChat = lazy(() => import("../../views/pages/cases/chat"))
const CaseAttachments = lazy(() => import("../../views/pages/cases/attachments"))
const CaseReviews = lazy(() => import("../../views/pages/cases/reviews"))
const CaseTransactions = lazy(() => import("../../views/pages/cases/transactions"))
const CaseServices = lazy(() => import("../../views/pages/cases/services"))
const Archived = lazy(() => import("../../views/pages/archived"))
const Shop = lazy(() => import("../../views/pages/shop"))
const ShopHome = lazy(() => import("../../views/pages/shop/home"))
const Notifications = lazy(() => import("../../views/pages/notifications"))
const Profile = lazy(() => import("../../views/pages/selfProfile"))
const Settingscoupons = lazy(() => import("../../views/pages/settings/coupons"))
const SettingsCouponsCreate = lazy(() =>
  import("../../views/pages/settings/coupons/create")
)
const SettingsCouponsView = lazy(() =>
  import("../../views/pages/settings/coupons/view/index")
)
const SettingsCouponsEdit = lazy(() =>
  import("../../views/pages/settings/coupons/edit/index")
)
const SettingsProducts = lazy(() =>
  import("../../views/pages/settings/products")
)
const SettingsProductsCreate = lazy(() =>
  import("../../views/pages/settings/products/create")
)
const SettingsProductsHome = lazy(() =>
  import("../../views/pages/settings/products/home")
)
const SettingsProductsEdit = lazy(() =>
  import("../../views/pages/settings/products/edit")
)
const SettingsWhatsApp = lazy(() =>
  import("../../views/pages/settings/whatsapp")
)
const SettingsUsers = lazy(() => import("../../views/pages/settings/users"))
const SettingsUsersCreate = lazy(() =>
  import("../../views/pages/settings/users/create")
)
const SettingsUsersView = lazy(() =>
  import("../../views/pages/settings/users/view")
)
const SettingsUsersEdit = lazy(() =>
  import("../../views/pages/settings/users/edit")
)
const Settings = lazy(() => import("../../views/pages/settings/general"))
const CartPage = lazy(() => import("../../views/pages/shop/cart"))
const CheckoutPage = lazy(() => import("../../views/pages/shop/checkout"))
const PaymentReturnPage = lazy(() => import("../../views/pages/shop/payment-return"))
const DentalArchDemo = lazy(() => import("../../views/pages/dental-arch-demo"))
const Orders = lazy(() => import("../../views/pages/orders"))
const OrderDetails = lazy(() => import("../../views/pages/orders/details"))
const Reports = lazy(() => import("../../views/pages/reports/ReportsRoute"))

const AppRoutes = [
  {
    element: <Reports />,
    path: "/reports"
  },
  {
    element: <Cases />,
    path: "/cases"
  },
  {
    element: <CasesHome />,
    path: "/cases/:hash"
  },
  {
    element: <CaseChat />,
    path: "/cases/:id/chat"
  },
  {
    element: <CaseAttachments />,
    path: "/cases/:id/attachments"
  },
  {
    element: <CaseReviews />,
    path: "/cases/:id/reviews"
  },
  {
    element: <CaseTransactions />,
    path: "/cases/:id/transactions"
  },
  {
    element: <CaseServices />,
    path: "/cases/:hash/services/:id"
  },
  {
    element: <Archived />,
    path: "/archived"
  },
  {
    element: <Shop />,
    path: "/shop",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor', 'planner']
    }
  },
  {
    element: <ShopHome />,
    path: "/shop/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor', 'planner']
    }
  },
  {
    element: <Notifications />,
    path: "/notifications"
  },
  {
    element: <Profile />,
    path: "/profile"
  },
  {
    element: <Settings />,
    path: "/settings/general",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <Settingscoupons />,
    path: "/settings/coupons",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsCouponsCreate />,
    path: "/settings/coupons/create",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsCouponsView />,
    path: "/settings/coupons/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsCouponsEdit />,
    path: "/settings/coupons/edit/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsProducts />,
    path: "/settings/products",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsProductsCreate />,
    path: "/settings/products/create",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsProductsHome />,
    path: "/settings/products/home/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsProductsEdit />,
    path: "/settings/products/edit/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <SettingsUsers />,
    path: "/settings/users",
    meta: {
      requiredRoles: ['admin']
    }
  },
  {
    element: <SettingsUsersCreate />,
    path: "/settings/users/create",
    meta: {
      requiredRoles: ['admin']
    }
  },
  {
    element: <SettingsUsersView />,
    path: "/settings/users/:id",
    meta: {
      requiredRoles: ['admin']
    }
  },
  {
    element: <SettingsUsersEdit />,
    path: "/settings/users/edit/:id",
    meta: {
      requiredRoles: ['admin']
    }
  },
  {
    element: <SettingsWhatsApp />,
    path: "/settings/whatsapp",
    meta: {
      requiredRoles: ['admin', 'supervisor']
    }
  },
  {
    element: <Orders />,
    path: "/orders",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
    }
  },
  {
    element: <OrderDetails />,
    path: "/orders/:id",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
    }
  },
  {
    element: <CartPage />,
    path: "/shop/cart",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
    }
  },
  {
    element: <CheckoutPage />,
    path: "/shop/checkout",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
    }
  },
  {
    element: <PaymentReturnPage />,
    path: "/shop/payment-return",
    meta: {
      requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
    }
  },
  {
    element: <DentalArchDemo />,
    path: "/dental-arch-demo"
  }
]

export default AppRoutes
